// extracted by mini-css-extract-plugin
export var BtnV2 = "PaperformEmbed-module--BtnV2--dd613";
export var BtnV2Black = "PaperformEmbed-module--BtnV2--black--545ea";
export var BtnV2Borderless = "PaperformEmbed-module--BtnV2--borderless--79ef3";
export var BtnV2Cloud = "PaperformEmbed-module--BtnV2--cloud--70454";
export var BtnV2Disabled = "PaperformEmbed-module--BtnV2--disabled--e976d";
export var BtnV2Focusable = "PaperformEmbed-module--BtnV2--focusable--58810";
export var BtnV2Fullwidth = "PaperformEmbed-module--BtnV2--fullwidth--2a168";
export var BtnV2Gold = "PaperformEmbed-module--BtnV2--gold--7026f";
export var BtnV2Grey = "PaperformEmbed-module--BtnV2--grey--1ab56";
export var BtnV2Icon = "PaperformEmbed-module--BtnV2--icon--7fe6a";
export var BtnV2Lg = "PaperformEmbed-module--BtnV2--lg--f082c";
export var BtnV2Midnight = "PaperformEmbed-module--BtnV2--midnight--24ece";
export var BtnV2Multiline = "PaperformEmbed-module--BtnV2--multiline--b5b81";
export var BtnV2Nofocus = "PaperformEmbed-module--BtnV2--nofocus--f9226";
export var BtnV2Secondary = "PaperformEmbed-module--BtnV2--secondary--1e645";
export var BtnV2Sm = "PaperformEmbed-module--BtnV2--sm--92443";
export var BtnV2Solid = "PaperformEmbed-module--BtnV2--solid--3aa04";
export var BtnV2Square = "PaperformEmbed-module--BtnV2--square--88244";
export var BtnV2Success = "PaperformEmbed-module--BtnV2--success--13662";
export var BtnV2Text = "PaperformEmbed-module--BtnV2--text--b65bd";
export var BtnV2Warning = "PaperformEmbed-module--BtnV2--warning--6e0c3";
export var BtnV2White = "PaperformEmbed-module--BtnV2--white--9ced5";
export var BtnV2Xl = "PaperformEmbed-module--BtnV2--xl--3a7b0";
export var BtnV2Yellow = "PaperformEmbed-module--BtnV2--yellow--0cda1";
export var ColorBlock = "PaperformEmbed-module--ColorBlock--3317a";
export var ColorBlockColorGrey = "PaperformEmbed-module--ColorBlock--colorGrey--ae653";
export var ColorBlockGrey = "PaperformEmbed-module--ColorBlock--grey--676eb";
export var ColorBlockMidGrey = "PaperformEmbed-module--ColorBlock--midGrey--9466e";
export var ColorBlockPink = "PaperformEmbed-module--ColorBlock--pink--5d184";
export var ColorBlockPrimary = "PaperformEmbed-module--ColorBlock--primary--bef41";
export var ColorBlockPrimaryDark = "PaperformEmbed-module--ColorBlock--primaryDark--cfec9";
export var ColorBlockPrimaryLight = "PaperformEmbed-module--ColorBlock--primaryLight--f8a25";
export var ColorBlockPrimaryMid = "PaperformEmbed-module--ColorBlock--primaryMid--d611a";
export var ColorBlockPurple = "PaperformEmbed-module--ColorBlock--purple--7901d";
export var ColorBlockRed = "PaperformEmbed-module--ColorBlock--red--cc8d1";
export var ColorBlockSecondary = "PaperformEmbed-module--ColorBlock--secondary--6112c";
export var ColorBlockSecondaryDark = "PaperformEmbed-module--ColorBlock--secondaryDark--8c7ed";
export var ColorBlockSecondaryLight = "PaperformEmbed-module--ColorBlock--secondaryLight--3634c";
export var ColorBlockSecondaryMid = "PaperformEmbed-module--ColorBlock--secondaryMid--46f94";
export var ColorBlockText = "PaperformEmbed-module--ColorBlock--text--5b70e";
export var ColorBlockYellow = "PaperformEmbed-module--ColorBlock--yellow--e028b";
export var ColorBlocks = "PaperformEmbed-module--ColorBlocks--d02e4";
export var DashboardTopoptions = "PaperformEmbed-module--Dashboard--topoptions--fd520";
export var HideEmbedded = "PaperformEmbed-module--HideEmbedded--4aaf5";
export var ShowEmbedded = "PaperformEmbed-module--ShowEmbedded--1f95c";
export var Template__descriptionContent = "PaperformEmbed-module--Template__description-content--44da5";
export var __active = "PaperformEmbed-module--__active--4de16";
export var __custom = "PaperformEmbed-module--__custom--af6b1";
export var _pin = "PaperformEmbed-module--_pin--0193b";
export var _pinText = "PaperformEmbed-module--_pinText--4557c";
export var aliceCarousel__dots = "PaperformEmbed-module--alice-carousel__dots--1cbc6";
export var aliceCarousel__dotsItem = "PaperformEmbed-module--alice-carousel__dots-item--16b82";
export var btnGroup = "PaperformEmbed-module--btn-group--9765f";
export var ccCompliance = "PaperformEmbed-module--cc-compliance--c8eab";
export var formSectionEmbed = "PaperformEmbed-module--formSectionEmbed--ad5fd";
export var h1 = "PaperformEmbed-module--h1--c8148";
export var h2 = "PaperformEmbed-module--h2--05c8f";
export var h3 = "PaperformEmbed-module--h3--16435";
export var h4 = "PaperformEmbed-module--h4--3f199";
export var link = "PaperformEmbed-module--link--6313e";
export var maxWidth = "PaperformEmbed-module--max-width--731bb";
export var menuOpen = "PaperformEmbed-module--menu-open--d4e8d";
export var noChildPMb = "PaperformEmbed-module--no-child-p-mb--4ef6e";
export var nobar = "PaperformEmbed-module--nobar--035f7";
export var pin = "PaperformEmbed-module--pin--22702";
export var seogroup = "PaperformEmbed-module--seogroup--a58ec";